import React, { useState } from 'react';
import ImgHappy from '@/assets/2025/topic900/correct_icon.png';
import ImgUnHappy from '@/assets/2025/topic900/error_icon.png';
import { Button, Radio, RadioChangeEvent, Drawer } from 'antd';
import { useStore } from '../../../../store';
interface IQuizOption {
  indicator?: string;
  title: any;
  explanation: any;
  isCorrect: boolean;
}

interface IFinalQuizProps {
  // description: any;
  question: any;
  options: any;
  quizIndex: number;
  quizCount: number;
  onSubmit?: (selected: IQuizOption) => void;
  onNext?: (isLast: boolean) => void;
  onPrev?: () => void;
  answer: any;
}
const INDICATORS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

const FinalQuiz: React.FunctionComponent<IFinalQuizProps> = (props) => {
  const {
    // description,
    question,
    options,
    onSubmit,
    onNext,
    onPrev,
    quizIndex,
    quizCount,
    answer,
  } = props;

  const { language } = useStore();
  const settings = answer;
  options.forEach((item: any, index: number) => {
    item.indicator = INDICATORS[index];
  });
  const [state, setState] = useState<{
    submitted: boolean;
    selected: IQuizOption | undefined;
    selectedValue: string;
  }>({
    submitted: false,
    selected: undefined,
    selectedValue: '',
  });
  const [open, setOpen] = useState(false);
  const onSelected = (e: RadioChangeEvent) => {
    if (state.submitted) {
      return;
    }
    setState({
      ...state,
      selectedValue: e.target.value,
      selected: options.find(
        (option: any) => option.indicator === e.target.value
      ),
    });
  };
  // eslint-disable-next-line no-unused-vars
  const last = () => {
    onPrev && onPrev();
  };
  const submit = () => {
    setOpen(true);
    if (!state.selected) {
      return;
    }
    setState({
      ...state,
      submitted: true,
    });
    if (typeof onSubmit === 'function') {
      onSubmit(state.selected);
    }
  };
  React.useEffect(() => {
    if (state.submitted) {
      document?.querySelector('.final-quiz-container')?.scrollTo({
        top: 0,
        left: 0,
      });
    }
  }, [state.submitted]);

  const next = () => {
    onNext && onNext(quizIndex === quizCount);

    setState({
      ...state,
      submitted: false,
    });
  };
  return (
    <div id={`q-${quizIndex}`} className="quiz-section">
      <div className="quiz-section-body">
        <div className="quiz-index">
          {quizIndex}/{quizCount}
        </div>
        {/*<div className="quiz-title">{settings?.titleLabel}</div>*/}
        <div
          className="quiz-question"
          dangerouslySetInnerHTML={{
            __html: `${quizIndex}. ${question[language]} `,
          }}
        />
        <div className="quiz-answers">
          <Radio.Group onChange={onSelected} value={state.selectedValue}>
            {options.map((option: any, index: number) => (
              <div key={index} className="quiz-answers-item">
                <div key={index} className="quiz-answers-item">
                  <Radio value={option.indicator}>
                    <span className="indicator">{option.indicator}</span>
                    {option.title[language]}
                  </Radio>
                </div>
              </div>
            ))}
          </Radio.Group>
        </div>
        <div className="quiz-button-section">
          <Button
            disabled={state.selectedValue === ''}
            onClick={submit}
            className="quiz-submit-button"
            type="text"
          >
            <span>{settings?.submitLabel}</span>
          </Button>
        </div>
        <Drawer
          maskClosable={false}
          placement="right"
          closable={false}
          open={open}
          getContainer={false}
          style={{ position: 'absolute' }}
        >
          <div
            className={`quiz-result-area ${
              state.selected?.isCorrect ? 'correct' : 'wrong'
            }`}
          >
            <img
              src={state.selected?.isCorrect ? ImgHappy : ImgUnHappy}
              alt=""
            />
            <h3 className="result-text">
              {state.selected?.isCorrect
                ? settings?.correctLabel
                : settings?.wrongLabel}
            </h3>
            <p
              className="explanation"
              dangerouslySetInnerHTML={{
                __html: state.selected?.explanation[language] || '',
              }}
            />
            <Button
              onClick={next}
              className="quiz-try-again-button"
              type="link"
            >
              {quizIndex === quizCount ? (
                <span>{settings?.checkResult}</span>
              ) : (
                <span>{settings?.nextLabel}</span>
              )}
            </Button>
          </div>
        </Drawer>
      </div>
    </div>
  );
};

FinalQuiz.defaultProps = {
  onSubmit: undefined,
  onNext: undefined,
  onPrev: undefined,
};

export default FinalQuiz;
